var map = {
	"./": 138,
	"./Clutch": 2721,
	"./Clutch.js": 2721,
	"./NewUi": 2722,
	"./NewUi.js": 2722,
	"./OldUi": 2723,
	"./OldUi.js": 2723,
	"./index": 138,
	"./index.js": 138,
	"./style": 867,
	"./style.js": 867
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4258;